import { LoadingButton } from '@mui/lab';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { Formik } from 'formik';

import * as Yup from 'yup';
import { InputAdornment, TextField } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export default function Login() {
   
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [isWrong, setIsWrong] = useState(false);
    const [showpass, setShowpass] = useState(false);
    

    const { login,isAuthenticated } = useAuth();

    

    // inital login credentials
const initialValues = {
    email: '',
    password: '',
    remember: true,
  };
  
  
  
  // form field validation schema
  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .min(6, 'Password must be 6 character length')
      .required('Password is required!'),
    email: Yup.string().email('Invalid Email address').required('Email is required!'),
  });
  
    const handleFormSubmit = async (values) => {
        setLoading(true);
        try {
          await login(values.email, values.password);
          setIsWrong(false)
          navigate('/select');
        } catch (e) {
          console.log("ERROR CREDENTIALS")
          setIsWrong(true)
          setLoading(false);
        }
      };

      
  
  

    return (
        <div className="flex flex-col self-center w-2/3 pt-10 ">
        <div className='w-full pb-[8px] m-auto bg-gradient-to-r from-app_green to-app_blue rounded-[50px] lg:max-w-xl'>
            <div className="w-full bg-white p-10 m-auto shadow-[0_15px_50px_10px_rgba(100,100,100,0.35)] rounded-[50px] lg:max-w-xl">
                {/* <h1 className="text-3xl font-semibold text-center text-app_green">
                   Sign in
                </h1> */}
                     <Formik
                enableReinitialize
                onSubmit={handleFormSubmit}
                initialValues={initialValues}
                validationSchema={validationSchema}
                // enableReinitialize={false}
              >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                 <form className="pb-5 mt-8" onSubmit={handleSubmit} pre>
                 <div className="flex">
                     <svg xmlns="http://www.w3.org/2000/svg" className="self-center w-12 p-2 mr-3 rounded-full h-11 stroke-white bg-app_green_light" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                         <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                     </svg>
                     
                     <div className="w-full  ">
                         {/* <label
                         for="email"
                         className="block text-sm font-semibold text-gray-800"
                     >
                         Username
                     </label> */}
                   <TextField
                //    className="block w-full px-4 py-2 mt-2 bg-white border rounded-2xl focus:border-app_green focus:ring-app_green_light focus:outline-none focus:ring focus:ring-opacity-40"
                   fullWidth
                   size="small"
                   type="email"
                   name="email"
                   label="Email/UserName"
                   variant="outlined"
                   onBlur={handleBlur}
                   value={values.email}
                   onChange={handleChange}
                   helperText={touched.email && errors.email}
                   error={Boolean(errors.email && touched.email)}
                   sx={{ borderRadius: '55px !important', }}
                  
                 />
                     </div>
                 </div>
                 <div className="flex pt-2">
                     <svg xmlns="http://www.w3.org/2000/svg" className="self-center w-12 p-2 mr-3 rounded-full h-11 stroke-white bg-app_green_light" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                         <path strokeLinecap="round" strokeLinejoin="round" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                     </svg>
                     <div className="w-full mb-5 ">

                         {/* <label
                             for="password"
                             className="block text-sm font-semibold text-gray-800"
                         >
                             Password
                         </label> */}
                         
                    <TextField
                    className=' !mt-5'
                      fullWidth
                      size="small"
                      pas
                      name="password"                      
                      label="Password"
                      variant="outlined"
                      type = { showpass ? "text" : "password" }
                      onBlur={handleBlur}
                      value={values.password}
                      onChange={handleChange}
                      helperText={touched.password && errors.password}
                      error={Boolean(errors.password && touched.password)}
                    //   sx={{ mb: 12 }}
                      InputProps = {
                        {
                          endAdornment: ( 
                          <InputAdornment position="end"> {
                            showpass ? ( 
                              <Visibility className = "cursor_pointer"
                                onClick = {
                                  ()=>{
                                    setShowpass(false)
                                   }
                                }
                                />
                              ) : ( 
                              <VisibilityOff onClick = {
                                   
                                   ()=>{
                                    setShowpass(true)
                                   }
                                }
                                />
                              )
                            } 
                            </InputAdornment>
                          ),
                        }}
                    />


                     </div>
                 </div>
                 {/* <a
                     href="/#"
                     className="flex justify-center mt-3 text-xs hover:underline"
                 >
                     Ξέχασα τους κωδικούς μου
                 </a> */}
                 <div className="flex justify-center mt-8 flex-col items-center">
                     {/* <Link to={"/select"} className=" text-white bg-gradient-to-r from-app_green  to-app_green_light hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-semibold rounded-full text-2xl px-16 py-3 text-center">
                     Είσοδος
                     </Link> */}
                     <LoadingButton
                 className='!w-48  h-16 text-white bg-gradient-to-r from-app_green  to-app_green_light hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-semibold !rounded-full !text-lg !normal-case px-16 py-3 text-center'
                   type="submit"
                 //   color="primary"
                 //   size='large'
                 
                   loading={loading}
                   variant="contained"
                   sx={{ my: 2 }}
                 >
                   Είσοδος
                 </LoadingButton>
                 {isWrong ? <div className=' text-red-400 '>Λάθος στοιχεία εισόδου!</div> : null}
                 </div>
                 
                 

             </form>
                )}
              </Formik>
                

                {/* <p className="mt-8 text-xs font-light text-center text-gray-700">
                    {" "}
                    Don't have an account?{" "}
                    <a
                        href="#"
                        className="font-medium text-purple-600 hover:underline"
                    >
                        Sign up
                    </a>
                </p> */}

            </div>
</div>

        </div>
    );
}